import React, { ReactElement } from "react";
import { Record, FormTab, required, TextInput, TabbedForm } from "react-admin";
import { NotificationRecipientsSelector } from "./NotificationRecipientsSelector";
import { GenericDateOrTimePicker } from "../../common/form/GenericDateOrTimePicker";
import { TimePicker } from "@material-ui/pickers";
import { NotificationSubscriptionEventTypesTab } from "./NotificationSubscriptionEventTypesTab";
import "./NotificationSubscriptionForm.css";
import { NotificationSubscriptionDriversTab } from "./NotificationSubscriptionDriversTab";
import { NotificationSubscriptionVehiclesTab } from "./NotificationSubscriptionVehiclesTab";
import { NotificationSubscriptionDto } from "../../../common/data/service-proxies";
import { ProtectedElement } from "../../common/field-permissions/ProtectedElement";

interface Props {
  record?: NotificationSubscriptionDto & Record;
  toolbar?: ReactElement;
}

const validateSendWindow = (
  message: string = "resources.admin-notifications.labels.youMustSpecifyBothTimes"
) => (_value: any, allValues: Partial<NotificationSubscriptionDto>) => {
  if (
    (allValues.sendWindowStartTime && !allValues.sendWindowEndTime) ||
    (!allValues.sendWindowStartTime && allValues.sendWindowEndTime)
  ) {
    return message;
  }
};

export const NotificationSubscriptionForm = (props: Props) => {
  return (
    <TabbedForm
      className="form-create-edit notification-subscription-form"
      variant="outlined"
      {...props}>
      <FormTab label="resources.admin-notifications.labels.notificationSettings">
        <ProtectedElement
          source="name"
          label="resources.admin-notifications.labels.name"
          validate={required()}>
          <TextInput source="name" />
        </ProtectedElement>
        <ProtectedElement
          source="sendWindowStartTime"
          label="resources.admin-notifications.labels.sendWindowStartTime"
          validate={validateSendWindow()}>
          <GenericDateOrTimePicker
            source="sendWindowStartTime"
            PickerComponent={TimePicker}
          />
        </ProtectedElement>
        <ProtectedElement
          source="sendWindowEndTime"
          label="resources.admin-notifications.labels.sendWindowEndTime"
          validate={validateSendWindow()}>
          <GenericDateOrTimePicker
            PickerComponent={TimePicker}
            source="sendWindowEndTime"
          />
        </ProtectedElement>
      </FormTab>
      <FormTab label="resources.admin-notifications.labels.notificationRecipients">
        <NotificationRecipientsSelector />
      </FormTab>
      <NotificationSubscriptionEventTypesTab />
      <NotificationSubscriptionDriversTab />
      <NotificationSubscriptionVehiclesTab />
    </TabbedForm>
  );
};
